import AIContainer from './ai-page.container';

export default AIContainer;